const directMailProductsList = [
    'SLS_33963', // Direct Mail Booklet
    'SLS_120405', // Direct Mail Booklet
    'SLS_57252', // Direct Mail Card
    'SLS_127472', // Direct Mail Magnet Postcards
    'SLS_99072', // Direct Mail Perfect Bound Booklets
    'SLS_40443', // Direct Mail Postage Smartpress
    'SLS_33964', // Direct Mail Postcard
    'SLS_78950', // Direct Mail Postcard
    'SLS_79187', // Direct Mail Postcard
    'SLS_79638', // Direct Mail Postcard
    'SLS_80257', // Direct Mail Postcard
    'SLS_82786', // Direct Mail Postcard
    'SLS_126492', // Direct Mail Postcard
    'SLS_128800', // Direct Mail Postcard
    'SLS_127482', // Direct Mail Sticker Postcards with Custom Shapes
    'SLS_127484', // Direct Mail Sticker Postcards with Standard Shapes
    'SLS_64760', // Letter Mailer
    'SLS_78956', // Letter Mailer
    'SLS_64762', // Letter Mailer with Reply
    'SLS_79628', // Letter Mailer with Reply
    'SLS_80249', // Letter Mailer with Reply
    'SLS_23621', // Newsletter
    'SLS_79637', // Newsletter
    'SLS_80240', // Newsletter
    'SLS_126491', // Newsletter
    'SLS_33962', // Self-Mailer
    'SLS_64761', // Window Letter Mailer
    'SLS_64763', // Window Letter Mailer with Reply
    'SLS_80029', // Direct Mail Postcard
    'SLS_80935', // Direct Mail Postcard
    'SLS_122997', // Direct Mail Postcard
    'SLS_125219', // Direct Mail Postcard
    'SLS_83095', // Patterson Window Letter Mailer
    'SLS_83412', // Patterson Window Letter Mailer
    'SLS_76617', // SPDC_MYP_ADO Bifold Self-Mailer
    'SLS_76613', // SPDC_MYP_ADO Direct Mail Postcard
    'SLS_76616', // SPDC_MYP_ADO Trifold Self-Mailer
    'SLS_77150', // SPDC_MYP_DM Postcard - Budget 2000
    'SLS_77151', // SPDC_MYP_DM Postcard - Budget 3000
    'SLS_76466', // SPDC_MYP_DM Postcard - Budget XXX
    'SLS_81805', // SPDC_MYP_DM Postcard - Budget XXX
    'SLS_81806', // SPDC_MYP_DM Postcard - Budget XXX
    'SLS_76539', // SPDC_MYP_DM Postcard - budget 2500
    'SLS_91427', // SPDC_MYP_Infinity Direct Postcards
    'SLS_93531', // SPDC_MYP_Infinity Direct Postcards
    'SLS_95113', // SPDC_MYP_Infinity Direct Postcards
    'SLS_95405', // SPDC_MYP_Infinity Direct Postcards
    'SLS_101381', // SPDC_MYP_Infinity Direct Postcards
    'SLS_126542', // SPDC_MYP_Infinity Direct Postcards
    'SLS_78181', // SPDC_MYP_PTM 6 x 11 Postcard
    'SLS_109470', // UNWSP Direct Mail Cards
    'SLS_120860', // Custom Quote - Direct Mail Card and Envelopes
    'SLS_128482', // Custom Quote - Direct Mail Catalogs
    'SLS_128461', // Custom Quote - Direct Mail Magnet Postcards
    'SLS_122555', // Custom Quote - Direct Mail Postcards
    'SLS_128457', // Custom Quote - Direct Mail Sticker Postcards with Custom Shapes
    'SLS_128458', // Custom Quote - Direct Mail Sticker Postcards with Standard Shapes
    'SLS_122956', // Custom Quote - Letter Mailers
    'SLS_122959', // Custom Quote - Letter Mailers with Reply Envelope
    'SLS_24927', // DM 4.25 x 6 Postcard
    'SLS_28036', // DM 6 x 11.5 Postcard
    'SLS_28035', // DM 6 x 9 Postcard
    'SLS_59367', // DO NOT USE - Direct Mail Letter
    'SLS_11403', // Every Door Direct Mail
    'SLS_120545', // Letter Mailer
    'SLS_64794', // Letter Mailer - #10 Closed Face Envelope
    'SLS_64785', // Letter Mailer - #10 Window Envelope
    'SLS_64786', // Letter Mailer - #9 Reply Envelope
    'SLS_120546', // Letter Mailer with Reply
    'SLS_83942', // Newsletter
    'SLS_83383', // SPDC_MYP_Infinity Direct Postcards
    'SLS_83384', // SPDC_MYP_Infinity Direct Postcards
    'SLS_83385', // SPDC_MYP_Infinity Direct Postcards
    'SLS_90619', // SPDC_MYP_Infinity Direct Postcards
    'SLS_91705', // SPDC_MYP_Infinity Direct Postcards
    'SLS_92026', // SPDC_MYP_Infinity Direct Postcards
    'SLS_95404', // SPDC_MYP_Infinity Direct Postcards
    'SLS_77319', // SPDC_MYP_Up North - Just Listed Postcard
]
export default directMailProductsList